export default "__VITE_ASSET__DiYcmnEr__"